<template>
  <div class="seagull-theme transfer">
    <v-app>
      <div style="padding-bottom: 54px">
        <div v-if="!userid && !hasCartarray">
          <v-container>
            <v-alert :value="true" color="warning" icon="priority_high" outline>
              {{ $t('Not found this page') }}
            </v-alert>
          </v-container>
        </div>
        <div v-else-if="isCompleted">
          <cover>
            <div slot="body" style="text-align: center; margin-top: -95px">
              <img
                src="@/assets/img/ecommerce/shopping_cart@4x.png"
                alt="shopping cart"
                style="width: 140px; padding-bottom: 10px"
              />
              <p style="padding-bottom: 10px">
                {{ $t('Payment Successfully') }}
              </p>
              <v-btn outline :color="theme.color" @click="goToShop()">
                {{ $t('Continue Shopping') }}
              </v-btn>
            </div>
          </cover>
        </div>
        <div v-else-if="isEmptyShoppingCart">
          <cover>
            <div slot="body" style="text-align: center; margin-top: -95px">
              <img
                src="@/assets/img/ecommerce/shopping_cart_out@4x.png"
                alt="empty shopping cart"
                style="width: 140px; padding-bottom: 10px"
              />
              <p style="padding-bottom: 10px">ไม่พบสินค้าในตะกร้า</p>

              <v-btn outline :color="theme.color" @click="goToShop()">
                {{ $t('Continue Shopping') }}
              </v-btn>
            </div>
          </cover>
        </div>
        <div
          v-show="
            (!isEmptyShoppingCart && !isCompleted && userid) || hasCartarray
          "
        >
          <merchant-detail
            v-model="pageProfile"
            :salePageShopName="salePage ? salePage.shop_name : ''"
            :salePageIsActive="salePage ? salePage.is_active : false"
          ></merchant-detail>

          <v-layout class="mt-5" wrap row v-if="isEditAddress">
            <v-flex xs12 sm6 offset-sm3 v-if="product_detail_json">
              <edit-cart-summary
                :productDetail="product_detail_json"
                :verifyData.sync="verifyDataEditPage"
              ></edit-cart-summary>
            </v-flex>
          </v-layout>

          <form
            id="checkout-form"
            class="checkout-form"
            method="POST"
            @submit.prevent="handleSubmit"
          >
            <v-container class="mt-5">
              <v-layout wrap row>
                <v-flex xs12 sm6 offset-sm3>
                  <h3
                    class="headline"
                    :style="{ color: theme.color }"
                    v-if="!isEditAddress"
                  >
                    <template v-if="$store.getters.isPowerBuyPage"
                      >กรุณากรอกข้อมูลเพื่อยืนยันสินค้าที่สนใจ</template
                    >
                    <template v-else> {{ $t('Payment') }}</template>
                  </h3>
                  <h3 class="headline" :style="{ color: theme.color }" v-else>
                    {{ $t('Shipping Address') }}
                  </h3>
                  <br />
                </v-flex>
                <v-flex xs12 sm6 offset-sm3>
                  <div
                    :class="{ 'has-error': errors.has('customerName') }"
                    class="mb-1"
                  >
                    <v-text-field
                      :label="$t('Name')"
                      :data-vv-as="$t('Name')"
                      outline
                      name="customerName"
                      v-validate="$route.query.shoptoken ? '' : 'required'"
                      v-model="customerName"
                      light
                      :color="theme.color"
                      :error="errors.has('customerName') ? true : false"
                      :error-messages="
                        errors.has('customerName')
                          ? errors.first('customerName')
                          : ''
                      "
                      @blur="onBlurAddress"
                    ></v-text-field>
                  </div>

                  <div
                    v-if="useOldAddress.includes(pageProfile.pageid)"
                    :class="{ 'has-error': errors.has('shippingAddress') }"
                    class="mb-1"
                  >
                    <v-textarea
                      outline
                      :label="$t('Shipping Address')"
                      name="shippingAddress"
                      rows="5"
                      :data-vv-as="$t('Shipping Address')"
                      style="resize: none; width: 100%"
                      v-model="shippingAddress"
                      v-validate="{
                        required: $route.query.shoptoken ? false : true,
                        regex: ['100203512915939', '111151505282962'].includes(
                          pageProfile.pageid
                        )
                          ? ''
                          : /([^0-9][1-9][0-9]{4})|^([1-9][0-9]{4})/,
                        isBearhousezipcode: [cart.length, isBearhouse]
                      }"
                      light
                      :color="theme.color"
                      :error="errors.has('shippingAddress') ? true : false"
                      :error-messages="
                        errors.has('shippingAddress')
                          ? errors.first('shippingAddress')
                          : ''
                      "
                      @blur="onBlurAddress"
                    ></v-textarea>
                  </div>
                  <template v-else>
                    <v-layout
                      style="display: -webkit-box"
                      v-if="deliveryOption && deliveryOption.length > 1"
                    >
                      <v-flex
                        class="pa-1"
                        v-if="
                          deliveryOption && deliveryOption.includes('delivery')
                        "
                      >
                        <v-btn
                          :color="
                            chooseShippingType == 'delivery'
                              ? theme.color
                              : 'grey'
                          "
                          depressed
                          :outline="chooseShippingType != 'delivery'"
                          block
                          dark
                          @click="selectShippingType('delivery')"
                        >
                          จัดส่งสินค้าตามที่อยู่
                        </v-btn>
                      </v-flex>
                      <v-flex
                        class="pa-1"
                        v-if="deliveryOption && deliveryOption.includes('map')"
                      >
                        <v-btn
                          :color="
                            chooseShippingType == 'map' ? theme.color : 'grey'
                          "
                          depressed
                          :outline="chooseShippingType != 'map'"
                          block
                          dark
                          @click="selectShippingType('map')"
                        >
                          จัดส่งสินค้าตามระยะทาง
                        </v-btn>
                      </v-flex>
                      <v-flex
                        class="pa-1"
                        v-if="
                          deliveryOption && deliveryOption.includes('lalamove')
                        "
                      >
                        <v-btn
                          :color="
                            chooseShippingType == 'lalamove'
                              ? theme.color
                              : 'grey'
                          "
                          depressed
                          :outline="chooseShippingType != 'lalamove'"
                          block
                          dark
                          @click="selectShippingType('lalamove')"
                        >
                          จัดส่งสินค้า Lalamove
                        </v-btn>
                      </v-flex>
                      <v-flex
                        class="pa-1"
                        v-if="
                          deliveryOption && deliveryOption.includes('pickup')
                        "
                      >
                        <v-btn
                          :color="
                            chooseShippingType == 'pickup'
                              ? theme.color
                              : 'grey'
                          "
                          depressed
                          :outline="chooseShippingType != 'pickup'"
                          block
                          dark
                          @click="selectShippingType('pickup')"
                        >
                          รับที่ร้าน
                        </v-btn>
                      </v-flex>
                    </v-layout>
                    <div
                      class="mb-3"
                      v-if="['lalamove', 'map'].includes(chooseShippingType)"
                    >
                      <template v-if="!loadingLastlocation">
                        <gmap-address
                          v-if="showmap"
                          :placesinfo="placesinfolabel"
                          :shippingType="chooseShippingType"
                          v-validate="{
                            required: $route.query.shoptoken ? false : true
                          }"
                          name="ปักหมุดที่อยู่"
                          v-model="gmapvalue"
                          v-on:input="gmapLocation"
                          :lastordercoords="gmapvalue"
                          :error="errors.has('ปักหมุดที่อยู่')"
                          :shoplocation="shoplocation"
                          :radius="0"
                          :scrollable="
                            ['alice', 'cityfresh'].includes(pageProfile.type)
                              ? false
                              : true
                          "
                          :infoloading="loadingMapInfo"
                          @onMapLoading="onMapLoading"
                          @onMapReady="onMapReady"
                        ></gmap-address>
                      </template>
                    </div>
                    <template
                      v-else-if="$store.getters.isPowerBuyPage"
                    ></template>
                    <template
                      v-else-if="
                        !setShopOption ||
                        (checkShopOption('Shipping Address') &&
                          checkShopOption('Shipping Address').is_require !==
                            'close' &&
                          checkShopOption('Shipping Address').status !== false)
                      "
                    >
                      <template v-if="chooseShippingType !== 'pickup'">
                        <template
                          v-if="
                            !['lalamove', 'map', 'custom'].includes(
                              chooseShippingType
                            )
                          "
                        >
                          <div
                            :class="{ 'has-error': errors.has('zipcode') }"
                            class="mb-1"
                          >
                            <thai-address-input
                              v-model="shippingAddress2.zipcode"
                              type="zipcode"
                              @select="onSelectAddress"
                              :label="$t('zipcode')"
                              :data-vv-as="$t('zipcode')"
                              outline
                              name="zipcode"
                              v-validate="{
                                required: $route.query.shoptoken
                                  ? false
                                  : setShopOption
                                  ? checkShopOption('Shipping Address')
                                      .is_require
                                  : true
                              }"
                              light
                              :color="theme.color"
                              :error="errors.has('zipcode') ? true : false"
                              :error-messages="
                                errors.has('zipcode')
                                  ? errors.first('zipcode')
                                  : ''
                              "
                              @blur="onBlurAddress"
                            ></thai-address-input>
                          </div>
                          <div
                            :class="{ 'has-error': errors.has('province') }"
                            class="mb-1"
                          >
                            <thai-address-input
                              v-model="shippingAddress2.province"
                              type="province"
                              @select="onSelectAddress"
                              :label="$t('province')"
                              :data-vv-as="$t('province')"
                              outline
                              name="province"
                              v-validate="{
                                required: $route.query.shoptoken
                                  ? false
                                  : setShopOption
                                  ? checkShopOption('Shipping Address')
                                      .is_require
                                  : true
                              }"
                              light
                              :color="theme.color"
                              :error="errors.has('province') ? true : false"
                              :error-messages="
                                errors.has('province')
                                  ? errors.first('province')
                                  : ''
                              "
                              @blur="onBlurAddress"
                            ></thai-address-input>
                          </div>
                          <div
                            :class="{ 'has-error': errors.has('amphoe') }"
                            class="mb-1"
                          >
                            <thai-address-input
                              v-model="shippingAddress2.district"
                              type="amphoe"
                              @select="onSelectAddress"
                              :label="$t('amphoe')"
                              :data-vv-as="$t('amphoe')"
                              outline
                              name="amphoe"
                              v-validate="{
                                required: $route.query.shoptoken
                                  ? false
                                  : setShopOption
                                  ? checkShopOption('Shipping Address')
                                      .is_require
                                  : true
                              }"
                              light
                              :color="theme.color"
                              :error="errors.has('amphoe') ? true : false"
                              :error-messages="
                                errors.has('amphoe')
                                  ? errors.first('amphoe')
                                  : ''
                              "
                              @blur="onBlurAddress"
                            ></thai-address-input>
                          </div>
                          <div
                            :class="{ 'has-error': errors.has('district') }"
                            class="mb-1"
                          >
                            <thai-address-input
                              v-model="shippingAddress2.sub_district"
                              type="district"
                              @select="onSelectAddress"
                              :label="$t('district')"
                              :data-vv-as="$t('district')"
                              outline
                              name="district"
                              v-validate="{
                                required: $route.query.shoptoken
                                  ? false
                                  : setShopOption
                                  ? checkShopOption('Shipping Address')
                                      .is_require
                                  : true
                              }"
                              light
                              :color="theme.color"
                              :error="errors.has('district') ? true : false"
                              :error-messages="
                                errors.has('district')
                                  ? errors.first('district')
                                  : ''
                              "
                              @blur="onBlurAddress"
                            ></thai-address-input>
                          </div>
                        </template>
                        <div
                          v-if="!['custom'].includes(chooseShippingType)"
                          :class="{
                            'has-error': errors.has('shippingAddress')
                          }"
                          class="mb-1"
                        >
                          <v-textarea
                            outline
                            :label="
                              useOldAddress.includes(pageProfile.pageid)
                                ? $t('Shipping Address')
                                : pageProfile.type == 'nestle'
                                ? $t('nestle_address_no')
                                : $t('Address No.')
                            "
                            name="shippingAddress"
                            rows="5"
                            :data-vv-as="
                              useOldAddress.includes(pageProfile.pageid)
                                ? $t('Shipping Address')
                                : pageProfile.type == 'nestle'
                                ? $t('nestle_address_no')
                                : $t('Address No.')
                            "
                            style="resize: none; width: 100%"
                            v-model="shippingAddress"
                            :placeholder="
                              $t('Ex. Address No., Village, Alley, and Road') +
                              (pageProfile.type == 'constructpage'
                                ? ` จุดสังเกตใกล้เคียง`
                                : '')
                            "
                            v-validate="{
                              required: $route.query.shoptoken
                                ? false
                                : setShopOption
                                ? checkShopOption('Shipping Address').is_require
                                : true
                            }"
                            light
                            :color="theme.color"
                            :error="
                              errors.has('shippingAddress') ? true : false
                            "
                            :error-messages="
                              errors.has('shippingAddress')
                                ? `${errors.first('shippingAddress')}`
                                : ''
                            "
                            @blur="onBlurAddress"
                          ></v-textarea>
                        </div>
                      </template>
                    </template>
                    <template
                      v-if="setShopOption && chooseShippingType == 'delivery'"
                    >
                      <template v-for="(option, i) in shopOption">
                        <div
                          v-if="
                            option.label !== '' &&
                            option.is_require !== 'close' &&
                            option.status !== false &&
                            option.label !== 'Shipping Address' &&
                            option.label !== 'Tel.' &&
                            option.label !== 'Name'
                          "
                          :key="i"
                          :class="{ 'has-error': errors.has(option.id) }"
                          class="mb-1"
                        >
                          <thai-address-input
                            v-model="option.message"
                            :type="option.type"
                            @select="onSelectAddress"
                            :label="$t(option.label)"
                            :data-vv-as="$t(option.label)"
                            outline
                            :name="option.id"
                            v-validate="{
                              required: $route.query.shoptoken
                                ? false
                                : option.is_require,
                              email: option.type === 'email' ? true : false
                            }"
                            light
                            :color="theme.color"
                            :error="errors.has(option.id) ? true : false"
                            :error-messages="
                              errors.has(option.id)
                                ? errors.first(option.id)
                                : ''
                            "
                          ></thai-address-input>
                        </div>
                      </template>
                    </template>
                  </template>

                  <div style="clear: both"></div>

                  <div
                    v-if="$store.state.cds.includes(pageid)"
                    :class="{ 'has-error': errors.has('remark') }"
                  >
                    <v-text-field
                      outline
                      :label="$t('The 1 Card Number') + ` (${$t('Optional')})`"
                      name="remark"
                      :data-vv-as="$t('The 1 Card Number')"
                      style="resize: none; width: 100%"
                      v-model="remark"
                      :color="theme.color"
                      light
                    ></v-text-field>
                  </div>
                  <div
                    v-if="['map'].includes(chooseShippingType)"
                    :class="{ 'has-error': errors.has('shippingAddress') }"
                    class="mb-1"
                  >
                    <v-textarea
                      outline
                      :label="$t('Shipping Address')"
                      name="shippingAddress"
                      rows="5"
                      :data-vv-as="$t('Shipping Address')"
                      style="resize: none; width: 100%"
                      v-model="shippingAddress"
                      v-validate="{
                        required: $route.query.shoptoken ? false : true,
                        regex: /([^0-9][1-9][0-9]{4})|^([1-9][0-9]{4})/,
                        isBearhousezipcode: [cart.length, isBearhouse]
                      }"
                      light
                      :color="theme.color"
                      :error="errors.has('shippingAddress') ? true : false"
                      :error-messages="
                        errors.has('shippingAddress')
                          ? errors.first('shippingAddress')
                          : ''
                      "
                      @blur="onBlurAddress"
                    ></v-textarea>
                  </div>
                  <div
                    :class="{ 'has-error': errors.has('customerPhone') }"
                    class="mb-1"
                    v-if="
                      !setShopOption ||
                      (checkShopOption('Tel.') &&
                        checkShopOption('Tel.').is_require !== 'close' &&
                        checkShopOption('Tel.').status !== false)
                    "
                  >
                    <v-text-field
                      :label="$t('Tel.') + ' ( Ex. 0999999999 ) '"
                      :data-vv-as="$t('Tel.')"
                      outline
                      tyle="tel"
                      name="customerPhone"
                      light
                      :color="theme.color"
                      v-validate="{
                        required: $route.query.shoptoken
                          ? false
                          : setShopOption
                          ? checkShopOption('Tel.').is_require
                          : true,
                        regex: requiredCharacterLength(checkShopOption('Tel.'))
                      }"
                      v-model="customerPhone"
                      :error="errors.has('customerPhone') ? true : false"
                      :error-messages="
                        errors.has('customerPhone')
                          ? errors.first('customerPhone')
                          : ''
                      "
                      @blur="onBlurAddress"
                    ></v-text-field>
                  </div>

                  <div
                    v-if="['custom'].includes(chooseShippingType)"
                    class="mb-1"
                  >
                    <p>
                      📍บริษัท สะดวก สะอาด ปลอดภัย จำกัด ที่อยู่ : 48/47 หมู่4
                      ถนนเอกชัย ต.นาดี อ.เมืองสมุทรสาคร จ.สมุทรสาคร 74000
                    </p>
                    <p>
                      เบอร์ติดต่อ : <a href="tel:034-870-951">034-870-951</a>
                    </p>
                    <p>
                      Google map :
                      <a
                        href="https://goo.gl/maps/1mxFzMPaAoipdwor7"
                        target="blank"
                        >https://goo.gl/maps/1mxFzMPaAoipdwor7</a
                      >
                    </p>
                  </div>

                  <div>
                    <!-- <v-checkbox
                      :label="$t('require_tax')"
                      v-model="needTaxInvoice"
                      color="theme.color"
                      @change="handleChangeTaxAddressSameAddress"
                    ></v-checkbox> -->
                    <template v-if="needTaxInvoice">
                      <div class="headline mb-3 primary--text">
                        {{ $t('info_tax') }}
                      </div>
                      <div
                        :class="{ 'has-error': errors.has('taxAddress') }"
                        class="mb-1"
                      >
                        <div
                          :class="{ 'has-error': errors.has('name') }"
                          class="mb-1"
                        >
                          <v-text-field
                            type="text"
                            :label="$t('Name')"
                            :data-vv-as="$t('Name')"
                            outline
                            maxlength="200"
                            name="name"
                            v-validate="{
                              required: true,
                              max: 200
                            }"
                            v-model="tax_name"
                            light
                            :color="theme.color"
                            :error="errors.has('name') ? true : false"
                            :error-messages="
                              errors.has('name') ? errors.first('name') : ''
                            "
                          ></v-text-field>
                        </div>
                        <v-textarea
                          outline
                          :label="$t('name_address')"
                          name="taxAddress"
                          rows="5"
                          :data-vv-as="$t('Shipping Address')"
                          style="resize: none; width: 100%"
                          v-model="taxAddress"
                          :placeholder="
                            $t('Ex. Address No., Village, Alley, and Road')
                          "
                          v-validate="{
                            required: $route.query.shoptoken ? false : true
                          }"
                          light
                          :color="theme.color"
                          :error="errors.has('taxAddress')"
                          :error-messages="
                            errors.has('taxAddress')
                              ? errors.first('taxAddress')
                              : ''
                          "
                        ></v-textarea>
                      </div>
                      <div
                        :class="{ 'has-error': errors.has('tax_id') }"
                        class="mb-1"
                      >
                        <v-text-field
                          type="number"
                          :label="$t('Tax ID number')"
                          :data-vv-as="$t('Tax ID number')"
                          outline
                          maxlength="13"
                          name="tax_id"
                          v-validate="{
                            required: false,
                            max: 13
                          }"
                          v-model="tax_id"
                          light
                          :color="theme.color"
                          :error="errors.has('tax_id') ? true : false"
                          :error-messages="
                            errors.has('tax_id') ? errors.first('tax_id') : ''
                          "
                        ></v-text-field>
                      </div>
                      <!-- <div style="text-align: center">
                      <v-btn
                        outline
                        :color="theme.color"
                        @click="
                          {
                            dialogtaxInvoice = false;
                            tax_id = '';
                          }
                        "
                      >
                        {{ $t("Close") }}
                      </v-btn>
                      <v-btn
                        :disabled="errors.has('tax_id')"
                        style="color: #ffffff"
                        :color="theme.color"
                        @click="dialogtaxInvoice = false"
                      >
                        {{ $t("บันทึก") }}
                      </v-btn>
                    </div> -->
                    </template>
                    <!-- <v-layout row justify-center>
                    <template>
                      <v-btn
                        @click="
                          setTaxInvoice();
                          dialogtaxInvoice = true;
                        "
                        :color="tax_id !== '' ? theme.color : 'grey'"
                        depressed
                        :outline="tax_id === ''"
                        block
                        dark
                      >
                      </v-btn>
                    </template>
                    
                  </v-layout> -->
                  </div>

                  <template
                    v-if="pageProfile.type == 'nvbb' && hasOtherProduct"
                    &&
                    !isEditAddress
                  >
                    <div :style="{ color: theme.color }">
                      **** สินค้าบางชนิดไม่ได้อยู่ในแพคเกจกรุณาเลือกวิธีจัดส่ง
                    </div>
                    <v-radio-group
                      v-model="hasShippingNow"
                      row
                      @change="changeHasShippingNow"
                    >
                      <v-radio
                        :label="`จัดส่งพร้อมกับแพคเกจ`"
                        :value="false"
                        :color="theme.color"
                      ></v-radio>
                      <v-radio
                        :label="`จัดส่งทันที  (มีค่าส่งเพิ่มเติม)`"
                        :value="true"
                        :color="theme.color"
                      ></v-radio>
                    </v-radio-group>
                  </template>
                  <template
                    v-if="chooseShippingType == 'delivery' && !isEditAddress"
                  >
                    <template
                      v-if="pageProfile.type == 'nvbb' && hasShippingNow"
                    >
                      <shipping-type
                        v-model="shippingType"
                        @onChange="changeShippingType"
                        :shippinglist="nvbbshippinglist"
                        :additionalproduct_charge="additionalproduct_charge"
                        :pageid="pageProfile.pageid"
                        :total="billing_subtotal"
                        :transportlists="transport_lists"
                      ></shipping-type>
                    </template>
                    <template
                      v-if="
                        pageProfile &&
                        pageProfile.pageid &&
                        shippinglist &&
                        !isOoca &&
                        pageProfile.type != 'nvbb'
                      "
                    >
                      <shipping-type
                        v-show="!isNestle"
                        :customerShippingPrice="customerShippingPrice"
                        :bearhouseshippingprice="bearhouseshippingprice"
                        :cdsshippingprice="cdsshippingprice"
                        v-model="shippingType"
                        @onChange="changeShippingType"
                        :shippinglist="shippinglist"
                        :additionalproduct_charge="additionalproduct_charge"
                        :pageid="pageProfile.pageid"
                        :total="billing_subtotal"
                        :key="timestamp"
                        :weight="weight"
                        :salePageActive="salePage ? salePage.is_active : false"
                        :quantityType="quantityType"
                        :transportlists="transport_lists"
                      ></shipping-type>
                    </template>
                  </template>
                </v-flex>
              </v-layout>
            </v-container>
            <v-divider v-if="!isEditAddress"></v-divider>
            <v-container
              class="mt-3"
              v-if="
                !isEditAddress ||
                (product_detail_json &&
                  product_detail_json.created_by.includes('admin'))
              "
            >
              <v-layout wrap row>
                <v-flex xs12 sm6 offset-sm3>
                  <template
                    v-if="
                      !isEditAddress ||
                      (product_detail_json &&
                        !product_detail_json.created_by.includes('admin') &&
                        product_detail_json.status === 'pending')
                    "
                  >
                    <h3
                      class="headline mb-3 text-xs-center"
                      :style="{ color: theme.color }"
                    >
                      {{ $t('Payment Detail') }}
                    </h3>
                    <cart-summary
                      :key="`cartsummary_${timestamp}`"
                      :customerShippingPrice="customerShippingPrice"
                      :notShipping="notShipping"
                      :cdsshippingprice="cdsshippingprice"
                      :bearhouseshippingprice="bearhouseshippingprice"
                      :total="billing_total"
                      :totalincludediscount="billing_subtotal"
                      :discount="discount"
                      :voucher="voucher"
                      :shippingType="shippingType"
                      :additionalproduct_charge="additionalproduct_charge"
                      :exceptCashOnDelivery="exceptCashOnDelivery"
                      :transportCode="transport_code"
                      :transportCost="transport_cost"
                      :ableToBuy="ableToBuy"
                      :zipCode="shippingAddress2.zipcode"
                    ></cart-summary>

                    <template>
                      <template
                        v-if="
                          !loading && pageProfile.egg_crm_status
                            ? true
                            : !['485851741439218'].includes(pageProfile.pageid)
                        "
                      >
                        <div v-if="$route.query.shoptoken && hasVoucher">
                          <v-btn
                            style="width: 45%"
                            small
                            :outline="!isVoucherCode"
                            :color="theme.color"
                            :disabled="discount === fixDiscount"
                            @click="
                              isVoucherCode = true
                              fixDiscount = null
                            "
                          >
                            <span :style="isVoucherCode ? 'color:#fff' : ''">{{
                              $t('voucher_code')
                            }}</span>
                          </v-btn>

                          <v-btn
                            style="width: 45%"
                            small
                            :outline="isVoucherCode"
                            :color="theme.color"
                            @click="isVoucherCode = false"
                            :disabled="voucher !== null"
                          >
                            <span :style="!isVoucherCode ? 'color:#fff' : ''">
                              {{ $t('Discount') }}</span
                            >
                          </v-btn>
                        </div>
                        <template
                          v-if="isVoucherCode && !loadingVoucher && hasVoucher"
                        >
                          <voucher-code-input
                            :shippingType="shippingType"
                            v-model="voucherCode"
                            @onUpdateTotal="onUpdateTotal"
                            :totalEgg="billing_total"
                            :exceptCashOnDelivery="exceptCashOnDelivery"
                            :selectedGiveAwayProduct="selectedGiveAwayProduct"
                            @handleSelectedGiveAwayProduct="
                              handleSelectedGiveAwayProduct
                            "
                          >
                            <template v-slot:append="{ hasGiveAways }">
                              <input
                                name="selectedGiveAwayProduct"
                                data-vv-as="ของแถม"
                                placeholder="ของแถม"
                                type="hidden"
                                v-model="selectedGiveAwayProduct"
                                v-validate="hasGiveAways ? 'required' : ''"
                              />
                              <div class="red--text">
                                {{
                                  errors.has('selectedGiveAwayProduct')
                                    ? 'กรุณาเลือกของแถม'
                                    : ''
                                }}
                              </div>
                            </template>
                          </voucher-code-input>
                        </template>
                        <template v-else>
                          <v-layout v-if="$route.query.shoptoken">
                            <v-flex>
                              <div
                                :class="{
                                  'has-error': errors.has('input_discount')
                                }"
                                class="mb-1"
                              >
                                <v-text-field
                                  outline
                                  :label="$t('input_discount')"
                                  name="input_discount"
                                  :data-vv-as="$t('Discount')"
                                  :color="theme.color"
                                  v-model="fixDiscount"
                                  maxlength="20"
                                  v-validate="{
                                    numeric: true
                                  }"
                                  light
                                  :error="
                                    errors.has('input_discount') ? true : false
                                  "
                                  :error-messages="
                                    errors.has('input_discount')
                                      ? errors.first('input_discount')
                                      : ''
                                  "
                                ></v-text-field>
                              </div>
                            </v-flex>
                            <v-flex shrink>
                              <v-btn
                                v-if="discount === fixDiscount"
                                outline
                                @click="
                                  fixDiscount = null
                                  onUpdateTotal(null)
                                "
                                color="red"
                              >
                                {{ $t('ยกเลิก') }}
                              </v-btn>
                              <v-btn
                                v-else
                                style="color: #ffffff"
                                @click="onUpdateTotal(null)"
                                :color="theme.color"
                              >
                                {{ $t('use_discount') }}
                              </v-btn>
                            </v-flex>
                          </v-layout>
                        </template>
                      </template>

                      <template v-if="pageProfile.egg_crm_status">
                        <v-radio-group v-model="isAddPoints">
                          <template v-slot:label>
                            <div>
                              <strong>
                                {{
                                  $t('Do customers want to collect points?')
                                }}</strong
                              >
                            </div>
                          </template>
                          <v-radio
                            :color="theme.color"
                            @click="
                              {
                                ;(dailogAddpoints = true),
                                  (isNotRegisterEgg = false),
                                  (memberPhoneNumber = customerPhone)
                              }
                            "
                            :value="true"
                          >
                            <template v-slot:label>
                              <div
                                @click="
                                  {
                                    ;(dailogAddpoints = true),
                                      (isNotRegisterEgg = false),
                                      (memberPhoneNumber = customerPhone)
                                  }
                                "
                              >
                                {{ $t('Want') }}
                                <small v-if="isAddPoints">
                                  (หมายเลขสมาชิก {{ memberPhoneNumber }})</small
                                >
                              </div>
                              <v-dialog
                                v-model="dailogAddpoints"
                                max-width="376"
                                persistent
                              >
                                <v-card>
                                  <div class="text-xs-right">
                                    <v-btn
                                      fab
                                      small
                                      flat
                                      @click="
                                        {
                                          ;(dailogAddpoints = false),
                                            (isAddPoints = false),
                                            (loading = false)
                                        }
                                      "
                                    >
                                      <v-icon>mdi-close</v-icon>
                                    </v-btn>
                                  </div>
                                  <v-card-text>
                                    <div class="mb-3">
                                      <v-layout>
                                        <v-flex>
                                          <div
                                            :class="{
                                              'has-error':
                                                errors.has('memberPhoneNumber')
                                            }"
                                            class="mb-1"
                                          >
                                            <v-text-field
                                              type="number"
                                              :label="
                                                $t('กรุณากรอกหมายเลขโทรศัพท์')
                                              "
                                              :data-vv-as="
                                                $t('หมายเลขโทรศัพท์')
                                              "
                                              outline
                                              name="memberPhoneNumber"
                                              v-validate="{
                                                required: false,
                                                regex: /^[+]?[0-9]{3,12}$/
                                              }"
                                              v-model="memberPhoneNumber"
                                              light
                                              :color="theme.color"
                                              :error="
                                                errors.has('memberPhoneNumber')
                                                  ? true
                                                  : false
                                              "
                                              :error-messages="
                                                errors.has('memberPhoneNumber')
                                                  ? errors.first(
                                                      'memberPhoneNumber'
                                                    )
                                                  : ''
                                              "
                                            ></v-text-field>
                                          </div>
                                          <!-- <v-text-field
                                      class="mb-1"
                                      type="number"
                                      outline
                                      maxlength="13"
                                      v-validate="{
                                        required: false,
                                        max: 13,
                                      }"
                                      label="กรุณากรอกหมายเลขโทรศัพท์"
                                      name="memberPhoneNumber"
                                      v-model="memberPhoneNumber"
                                      light
                                      :color="theme.color"
                                      :hide-details="true"
                                    ></v-text-field> -->
                                        </v-flex>
                                        <v-flex class="mt-1">
                                          <v-btn
                                            :color="theme.color"
                                            dark
                                            @click="CheckMemberPhoneNumber"
                                          >
                                            {{ $t('ตรวจสอบ') }}
                                          </v-btn>
                                        </v-flex>
                                      </v-layout>
                                      <div v-if="isNotRegisterEgg">
                                        <small
                                          >หมายเลขนี้ยังไม่ได้สมัครสมาชิก
                                          หากท่านต้องการสมัครสมาชิก
                                          สามารถกดยอมรับเงื่อนไขการใช้งาน
                                          และกดสมัครสมาชิก</small
                                        >
                                        <v-checkbox
                                          v-model="submitCheckbox"
                                          color="primary"
                                          class="mt-0"
                                        >
                                          <template v-slot:label>
                                            <v-dialog
                                              v-model="dialogPrivacyNotice"
                                              persistent
                                              width="600px"
                                            >
                                              <template
                                                v-slot:activator="{ on, attrs }"
                                              >
                                                <div
                                                  style="
                                                    display: grid;
                                                    font-size: 13px;
                                                  "
                                                >
                                                  <a v-bind="attrs" v-on="on">
                                                    ยอมรับเงื่อนไขการให้บริการและ</a
                                                  >
                                                  <v-dialog
                                                    v-model="
                                                      dialogTermAndCondition
                                                    "
                                                    persistent
                                                    width="600px"
                                                  >
                                                    <template
                                                      v-slot:activator="{
                                                        on,
                                                        attrs
                                                      }"
                                                    >
                                                      <a
                                                        v-bind="attrs"
                                                        v-on="on"
                                                      >
                                                        ยอมรับนโยบายความเป็นส่วนตัว</a
                                                      >
                                                    </template>
                                                    <v-card>
                                                      <v-card-title>
                                                        <span class="headline"
                                                          >Term and
                                                          condition</span
                                                        >
                                                      </v-card-title>
                                                      <v-card-text>
                                                        {{ term_and_condition }}
                                                      </v-card-text>
                                                      <v-card-actions>
                                                        <v-spacer></v-spacer>
                                                        <v-btn
                                                          color="primary"
                                                          outline
                                                          text
                                                          @click="
                                                            dialogTermAndCondition = false
                                                          "
                                                        >
                                                          ยอมรับ
                                                        </v-btn>
                                                      </v-card-actions>
                                                    </v-card>
                                                  </v-dialog>
                                                </div>
                                              </template>
                                              <v-card>
                                                <v-card-title>
                                                  <span class="headline"
                                                    >Privacy notice</span
                                                  >
                                                </v-card-title>
                                                <v-card-text>
                                                  {{ privacy_notice }}
                                                </v-card-text>
                                                <v-card-actions>
                                                  <v-spacer></v-spacer>
                                                  <v-btn
                                                    color="primary"
                                                    outline
                                                    text
                                                    @click="
                                                      dialogPrivacyNotice = false
                                                    "
                                                  >
                                                    ยอมรับ
                                                  </v-btn>
                                                </v-card-actions>
                                              </v-card>
                                            </v-dialog>
                                          </template>
                                        </v-checkbox>
                                        <!-- <a @click="registerMemberEgg"> สมัครสมาชิก</a> -->
                                        <v-btn
                                          :color="theme.color"
                                          :disabled="!submitCheckbox"
                                          block
                                          small
                                          @click="requestOtpEgg"
                                          style="color: #ffffff"
                                        >
                                          {{ $t('สมัครสมาชิก') }}
                                        </v-btn>

                                        <v-dialog
                                          v-model="dialogOtp"
                                          persistent
                                          width="400px"
                                        >
                                          <v-card>
                                            <div style="float: right">
                                              <v-btn
                                                fab
                                                small
                                                flat
                                                @click="
                                                  {
                                                    ;(dialogOtp = false),
                                                      (isAddPoints = false)
                                                  }
                                                "
                                              >
                                                <v-icon>mdi-close</v-icon>
                                              </v-btn>
                                            </div>
                                            <v-card-title>
                                              <div>
                                                <span class="headline"
                                                  >กรอกรหัส OTP</span
                                                >
                                              </div>
                                              <small
                                                >โปรดตรวจสอบรหัสใน SMS
                                                (รหัสอ้างอิง
                                                {{
                                                  refOtp
                                                    ? refOtp.reference
                                                    : ''
                                                }})</small
                                              >
                                            </v-card-title>
                                            <v-card-text>
                                              <vue-otp-box
                                                :numberOfBoxes="6"
                                                color="primary"
                                                position="center"
                                                @inputValue="inputValue"
                                              ></vue-otp-box>
                                            </v-card-text>
                                            <v-card-actions>
                                              <v-spacer></v-spacer>
                                              <!-- <v-btn
                                          color="primary"
                                          outline
                                          text
                                          @click="dialogOtp = false"
                                        >
                                          ยืนยัน
                                        </v-btn> -->
                                            </v-card-actions>
                                          </v-card>
                                        </v-dialog>
                                      </div>
                                    </div>
                                  </v-card-text>
                                </v-card>
                              </v-dialog>
                            </template>
                          </v-radio>
                          <v-radio :color="theme.color" :value="false">
                            <template v-slot:label>
                              <div>{{ $t("Don't want") }}</div>
                            </template>
                          </v-radio>
                        </v-radio-group>
                      </template>
                    </template>

                    <template v-if="['alice'].includes(pageProfile.type)">
                      <div class="text-xs-left">
                        ต้องการรับสินค้าในช่วงเวลา (สำหรับการส่ง EMS
                        และควบคุมอุณหภูมิ วันที่เลือกจะเป็นวันที่จัดส่งสินค้า)
                      </div>
                      <date-picker
                        color="primary"
                        v-model="pickupdate"
                        label="เลือกวันที่จัดส่ง/รับสินค้า"
                        :min="mindate"
                        :max="maxdate"
                        :key="pickupdate"
                        :allowed-dates="allowedDates"
                      >
                        <template v-slot="{ computedDate }">
                          <v-text-field
                            :value="computedDate"
                            label="เลือกวันที่จัดส่ง/รับสินค้า"
                            :data-vv-as="'วันที่รับสินค้า'"
                            prepend-inner-icon="event"
                            readonly
                            name="pickupdate"
                            v-validate="'required'"
                            :error="errors.has('pickupdate') ? true : false"
                            :error-messages="
                              errors.has('pickupdate')
                                ? errors.first('pickupdate')
                                : ''
                            "
                            outline
                            :color="theme.color"
                          ></v-text-field>
                        </template>
                      </date-picker>
                    </template>
                    <v-layout
                      v-if="
                        chooseShippingType === 'lalamove' &&
                        !['cityfresh'].includes(pageProfile.type) &&
                        !$store.getters.isPowerBuyPage
                      "
                    >
                      <v-flex class="mr-1">
                        <v-btn
                          :color="theme.color"
                          dark
                          block
                          small
                          @click="
                            lalamove.cod = false
                            gmapLocation()
                          "
                          :outline="lalamove.cod"
                        >
                          <v-icon small class="mr-2">mdi-cash-multiple</v-icon>
                          {{ $t('transfer') }}
                        </v-btn>
                      </v-flex>
                      <v-flex class="ml-1">
                        <v-btn
                          :color="theme.color"
                          dark
                          small
                          block
                          @click="selectCODLalamove"
                          :outline="!lalamove.cod"
                        >
                          <v-icon small class="mr-2"
                            >mdi-package-variant-closed</v-icon
                          >
                          {{ $t('cod_charge') }}
                        </v-btn>
                      </v-flex>
                    </v-layout>
                    <div
                      v-if="
                        !$store.state.cds.includes(pageid) &&
                        pageProfile.type != 'nestle' &&
                        !$store.getters.isPowerBuyPage
                      "
                      :class="{ 'has-error': errors.has('remark') }"
                      style="margin-bottom: 15px"
                    >
                      <v-textarea
                        outline
                        :label="
                          $t('Remark') +
                          (pageProfile.type == 'alice'
                            ? ' (ระบุเวลารับสินค้า/จุดสังเกตที่อยู่/รายละเอียดการจัดสินค้าเพิ่มเติ่ม)'
                            : '')
                        "
                        name="remark"
                        rows="5"
                        :data-vv-as="$t('Remark')"
                        style="resize: none; width: 100%"
                        v-model="remark"
                        :color="theme.color"
                        light
                        hide-details
                      ></v-textarea>
                    </div>

                    <template v-if="['mookata'].includes(pageProfile.type)">
                      <v-checkbox
                        label="ต้องการยืมกระทะ"
                        v-model="isBorrowPan"
                        :color="theme.color"
                        :value="true"
                      ></v-checkbox>

                      <v-card v-if="isBorrowPan" class="mb-4">
                        <v-card-text>
                          กรุณากรอกข้อมูลเพื่อทำการยืมกระทะ
                          <div class="mb-3"></div>

                          <v-text-field
                            class="mb-1"
                            outline
                            label="ชื่อ-นามสกุล"
                            data-vv-as="ชื่อ-นามสกุล"
                            name="borrowPanInfo.name"
                            v-model="borrowPanInfo.name"
                            light
                            :color="theme.color"
                            :hide-details="!errors.has('borrowPanInfo.name')"
                            v-validate="{
                              required: true
                            }"
                            :error="
                              errors.has('borrowPanInfo.name') ? true : false
                            "
                            :error-messages="
                              errors.has('borrowPanInfo.name')
                                ? errors.first('borrowPanInfo.name')
                                : ''
                            "
                          ></v-text-field>

                          <v-text-field
                            class="mb-1"
                            type="number"
                            max="3"
                            outline
                            label="อายุ"
                            data-vv-as="อายุ"
                            name="borrowPanInfo.age"
                            v-model="borrowPanInfo.age"
                            light
                            :color="theme.color"
                            :hide-details="!errors.has('borrowPanInfo.age')"
                            v-validate="{
                              required: true,
                              max: 3,
                              max_value: 100
                            }"
                            :error="
                              errors.has('borrowPanInfo.age') ? true : false
                            "
                            :error-messages="
                              errors.has('borrowPanInfo.age')
                                ? errors.first('borrowPanInfo.age')
                                : ''
                            "
                          ></v-text-field>
                          <v-text-field
                            :label="$t('เลขบัตรประชาชน')"
                            :data-vv-as="$t('เลขบัตรประชาชน')"
                            outline
                            :mask="'#-####-#####-##-#'"
                            maxlength="13"
                            name="borrowPanInfo.idcard"
                            v-validate="{
                              required: true,
                              max: 13
                            }"
                            v-model="borrowPanInfo.idcard"
                            light
                            :color="theme.color"
                            :hide-details="!errors.has('borrowPanInfo.idcard')"
                            :error="
                              errors.has('borrowPanInfo.idcard') ? true : false
                            "
                            :error-messages="
                              errors.has('borrowPanInfo.idcard')
                                ? errors.first('borrowPanInfo.idcard')
                                : ''
                            "
                          ></v-text-field>

                          <v-checkbox
                            label="หากอุปกรณ์ที่ยืมไปเกิดชำรุดหรือเสียสูญหายลูกค้ายินยอมที่จะรับผิดชอบตามราคาจริง"
                            v-model="borrowPanInfo.isaccept"
                            :color="theme.color"
                            :value="true"
                            data-vv-as="ยอมรับ"
                            name="borrowPanInfo.isaccept"
                            v-validate="'required'"
                            :error="
                              errors.has('borrowPanInfo.isaccept')
                                ? true
                                : false
                            "
                            :error-messages="
                              errors.has('borrowPanInfo.isaccept')
                                ? errors.first('borrowPanInfo.isaccept')
                                : ''
                            "
                          ></v-checkbox>
                        </v-card-text>
                      </v-card>
                    </template>
                  </template>

                  <div
                    v-if="
                      !product_detail_json ||
                      (product_detail_json &&
                        product_detail_json.status === 'pending')
                    "
                  >
                    <div style="padding-bottom: 25px">
                      <v-card>
                        <v-card-text>
                          <div>
                            <v-layout
                              row
                              wrap
                              class="mb-3"
                              v-if="!lalamove.cod && !$route.query.shoptoken"
                            >
                              <DefaultPaymentButton
                                v-if="paymentList.includes('gbprime')"
                                :paymentList="paymentList"
                                :transferType="transferType"
                                :type="'qrcode'"
                                @handleClick="
                                  transferType = 'qrcode'
                                  setShippingDefault()
                                "
                              >
                                <v-icon small class="mr-2">
                                  mdi-qrcode-scan
                                </v-icon>
                                QR CODE
                              </DefaultPaymentButton>
                              <DefaultPaymentButton
                                v-if="
                                  paymentList.includes('gbprime_mobile_banking')
                                "
                                :disabled="totalPrice < 20"
                                :paymentList="paymentList"
                                :transferType="transferType"
                                :type="'gbprime_mobile_banking'"
                                @handleClick="
                                  transferType = 'gbprime_mobile_banking'
                                  setShippingDefault()
                                "
                              >
                                <v-icon small class="mr-2">
                                  mdi-cash-multiple
                                </v-icon>
                                MOBILE BANKING
                              </DefaultPaymentButton>
                              <DefaultPaymentButton
                                v-if="
                                  paymentList.includes('transfer') &&
                                  !showOnlyQRpage
                                "
                                :paymentList="paymentList"
                                :transferType="transferType"
                                :type="'transfer'"
                                @handleClick="
                                  transferType = 'transfer'
                                  setShippingDefault()
                                "
                              >
                                <template v-if="$store.getters.isPowerBuyPage">
                                  ติดต่อแอดมิน
                                </template>
                                <template v-else>
                                  <v-icon small class="mr-2">
                                    mdi-cash-multiple
                                  </v-icon>
                                  {{ $t('transfer') }}</template
                                >
                              </DefaultPaymentButton>

                              <template
                                v-if="
                                  $store.state.page2c2p.includes(pageid) &&
                                  !['tero'].includes(pageProfile.type)
                                "
                              >
                                <DefaultPaymentButton
                                  v-if="paymentList.includes('2c2p')"
                                  :paymentList="paymentList"
                                  :transferType="transferType"
                                  :type="'2c2p'"
                                  @handleClick="
                                    transferType = '2c2p'
                                    setShippingDefault()
                                  "
                                >
                                  <template>
                                    <v-icon small class="mr-2"
                                      >mdi-credit-card</v-icon
                                    >
                                    <template
                                      v-if="
                                        pageProfile &&
                                        pageProfile.type == 'nestle'
                                      "
                                    >
                                      {{ $t('Payment') }}
                                    </template>
                                    <template
                                      v-else-if="
                                        [
                                          '104716585038207',
                                          '362065616073'
                                        ].includes(pageProfile.pageid) ||
                                        ['tero'].includes(pageProfile.type)
                                      "
                                    >
                                      {{ $t('Credit Cards') }}
                                    </template>
                                    <template v-else>
                                      {{ $t('2C2P Payment') }}
                                    </template>
                                  </template>
                                </DefaultPaymentButton>
                              </template>
                              <template v-else>
                                <DefaultPaymentButton
                                  v-if="paymentList.includes('2c2p')"
                                  :paymentList="paymentList"
                                  :transferType="transferType"
                                  :type="'fbpay'"
                                  @handleClick="
                                    transferType = 'fbpay'
                                    setShippingDefault()
                                  "
                                >
                                  <v-icon small class="mr-2"
                                    >mdi-credit-card</v-icon
                                  >
                                  {{ $t('Credit Cards') }}
                                </DefaultPaymentButton>
                              </template>

                              <DefaultPaymentButton
                                v-if="
                                  paymentList.includes('fbpay') &&
                                  userid &&
                                  !userid.includes('__')
                                "
                                :paymentList="paymentList"
                                :transferType="transferType"
                                :type="'fbpay'"
                                @handleClick="
                                  transferType = 'fbpay'
                                  setShippingDefault()
                                "
                              >
                                <v-icon small class="mr-2">
                                  mdi-cellphone-android
                                </v-icon>
                                {{ $t('Mobile Banking') }}
                              </DefaultPaymentButton>

                              <DefaultPaymentButton
                                v-if="paymentList.includes('cod') && userid"
                                :paymentList="paymentList"
                                :transferType="transferType"
                                :type="'cod_charge'"
                                @handleClick="
                                  transferType = 'cod_charge'
                                  setShippingDefault('cod_charge')
                                "
                              >
                                <v-icon small class="mr-2">
                                  mdi-package-variant-closed
                                </v-icon>
                                {{ $t('cod_charge') }}
                              </DefaultPaymentButton>

                              <DefaultPaymentButton
                                v-if="paymentList.includes('paypal') && userid"
                                :paymentList="paymentList"
                                :transferType="transferType"
                                :type="'paypal'"
                                @handleClick="
                                  transferType = 'paypal'
                                  renderPaypalBtn()
                                  setShippingDefault()
                                "
                              >
                                <v-icon small class="mr-2"
                                  >mdi-credit-card</v-icon
                                >
                                {{ $t('PayPal') }}
                              </DefaultPaymentButton>

                              <DefaultPaymentButton
                                v-if="
                                  paymentList.includes('creditgbprime') &&
                                  userid
                                "
                                :paymentList="paymentList"
                                :transferType="transferType"
                                :type="'creditgbprime'"
                                @handleClick="
                                  transferType = 'creditgbprime'
                                  setShippingDefault()
                                "
                              >
                                <v-icon small class="mr-2"
                                  >mdi-credit-card</v-icon
                                >
                                {{ $t('Credit Cards') }}
                              </DefaultPaymentButton>
                            </v-layout>

                            <v-layout
                              v-if="
                                ['gbprime_mobile_banking'].includes(
                                  transferType
                                )
                              "
                              row
                              wrap
                            >
                              <v-flex>
                                <label
                                  class="my-1"
                                  style="
                                    font-weight: bold;
                                    color: #555;
                                    font-size: 1.1rem;
                                  "
                                  >Select Bank</label
                                >
                                <v-radio-group v-model="gbFormData.bankCode">
                                  <v-radio
                                    v-for="(item, index) in gbBank"
                                    :key="`bank-option-${index}`"
                                    :label="item.text"
                                    :value="item.value"
                                  ></v-radio>
                                </v-radio-group>
                              </v-flex>
                            </v-layout>

                            <PaymentInfo :pageProfile="pageProfile" />

                            <p
                              class="text-xs-center"
                              v-if="
                                ['qrcode', 'gbprime_mobile_banking'].includes(
                                  transferType
                                )
                              "
                            >
                              {{
                                $t(
                                  'If paying by QR Code, please click the button {proceed_payment}” at the bottom.',
                                  {
                                    proceed_payment: isNestle
                                      ? 'ทำการสั่งซื้อ'
                                      : $store.getters.isPowerBuyPage
                                      ? 'ติดต่อแอดมิน'
                                      : $route.query.shoptoken
                                      ? $t('Proceed Payment1')
                                      : $t('Proceed Payment')
                                  }
                                )
                              }}
                            </p>

                            <!-- Cash on Delivery -->
                            <template
                              v-if="
                                (shippingType &&
                                  shippingType.type == 'cod_charge') ||
                                lalamove.cod
                              "
                            >
                              <div
                                class="text-xs-center"
                                style="padding-top: 15px; padding-bottom: 15px"
                              >
                                <a
                                  href="javascript:void(0);"
                                  @click="openModal()"
                                  style="color: rgb(169, 169, 169)"
                                >
                                  {{
                                    $t(
                                      'By clicking {proceed_payment}, Ive read and',
                                      {
                                        proceed_payment: isNestle
                                          ? 'ทำการสั่งซื้อ'
                                          : $store.getters.isPowerBuyPage
                                          ? 'ติดต่อแอดมิน'
                                          : 'ชำระสินค้า'
                                      }
                                    )
                                  }}
                                  <br />
                                  {{ $t('agree to') }}
                                  <span :style="{ color: theme.color }">
                                    นโยบายความเป็นส่วนตัวและการรับประกัน</span
                                  >.
                                </a>
                              </div>
                              <template v-if="loading">
                                <div class="text-xs-center my-3">
                                  <v-progress-circular
                                    :key="theme.color"
                                    indeterminate
                                    :color="theme.color"
                                  ></v-progress-circular>
                                </div>
                              </template>
                              <template v-else>
                                <p
                                  class="text-xs-center"
                                  style="color: red"
                                  v-if="isCartOutOfStock"
                                >
                                  {{
                                    $t(
                                      'Not enough products in stock, please try to order again.'
                                    )
                                  }}.
                                </p>
                                <div class="text-xs-center">
                                  <v-btn
                                    dark
                                    :color="theme.color"
                                    :disabled="loading || isCartOutOfStock"
                                    @click="handleSubmit"
                                    :loading="pageLoading || loadingMapInfo"
                                    v-if="!isCompletePayment"
                                  >
                                    <v-icon class="mr-2"
                                      >mdi-cart-outline</v-icon
                                    >
                                    {{
                                      isNestle
                                        ? 'ทำการสั่งซื้อ'
                                        : $store.getters.isPowerBuyPage
                                        ? 'ติดต่อแอดมิน'
                                        : $route.query.shoptoken
                                        ? $t('Proceed Payment1')
                                        : $t('Proceed Payment')
                                    }}
                                  </v-btn>
                                </div>
                              </template>
                            </template>

                            <template
                              v-else-if="
                                [
                                  'transfer',
                                  'fbpay',
                                  'gbprime_mobile_banking'
                                ].includes(transferType)
                              "
                            >
                              <div
                                v-if="
                                  ['transfer'].includes(transferType) &&
                                  !$route.query.shoptoken
                                "
                              >
                                <div
                                  class="mb-4"
                                  v-if="!$store.getters.isPowerBuyPage"
                                >
                                  <template v-if="banktransferinfo_photo">
                                    <img
                                      :src="banktransferinfo_photo"
                                      alt="bank transfer"
                                      style="
                                        border: 1px solid #eee;
                                        border-radius: 5px;
                                        margin-bottom: 15px;
                                        width: 100%;
                                      "
                                    />
                                  </template>
                                  <template v-if="banktransferinfo">
                                    <bank-number
                                      :text="banktransferinfo"
                                    ></bank-number>
                                  </template>
                                </div>

                                <div
                                  :class="{
                                    'has-error': errors.has('paymentSlipImage')
                                  }"
                                  class="mb-4"
                                  v-if="
                                    !shippingType ||
                                    (shippingType &&
                                      shippingType.type != 'cod_charge' &&
                                      !$store.getters.isPowerBuyPage)
                                  "
                                >
                                  <h3
                                    class="headline"
                                    :style="{ color: theme.color }"
                                  >
                                    {{ $t('Payment slip') }}
                                  </h3>
                                  <br />
                                  <template v-if="!isCartOutOfStock">
                                    <upload-file
                                      :outputtype="
                                        isCDS || pageProfile.type == 'monobo'
                                          ? 'base64'
                                          : 'url'
                                      "
                                      name="paymentSlipImage"
                                      v-validate="
                                        ((payment_slip_status === true ||
                                          payment_slip_status === 'true') &&
                                          !hasCartarray) ||
                                        $route.query.shoptoken
                                          ? ''
                                          : 'required'
                                      "
                                      :data-vv-as="$t('Payment Slip Image')"
                                      v-model="paymentSlipImage"
                                      :verifyData.sync="verifyData"
                                    ></upload-file>

                                    <template
                                      v-if="
                                        payment_slip_status && !hasCartarray
                                      "
                                    >
                                      <v-alert
                                        :value="true"
                                        color="info"
                                        icon="info"
                                        outline
                                      >
                                        {{ $t('slip_later_remark') }}
                                      </v-alert>
                                    </template>
                                  </template>
                                  <p
                                    class="caption ma-2"
                                    style="color: red"
                                    v-show="errors.has('paymentSlipImage')"
                                  >
                                    {{ errors.first('paymentSlipImage') }}
                                  </p>
                                </div>

                                <div
                                  v-if="pageProfile.type == 'monobo'"
                                  :class="{
                                    'has-error': errors.has('bankname')
                                  }"
                                  style="margin-bottom: 15px"
                                >
                                  <v-select
                                    v-model="bankname"
                                    outline
                                    label="บัญชีที่ลูกค้าทำการชำระ"
                                    key="บัญชี"
                                    data-vv-as="บัญชีที่ลูกค้าทำการชำระ"
                                    v-validate="'required'"
                                    :items="monobobanklist"
                                    name="bankname"
                                    :error="
                                      errors.has('bankname') ? true : false
                                    "
                                    :error-messages="
                                      errors.has('bankname')
                                        ? errors.first('bankname')
                                        : ''
                                    "
                                  ></v-select>
                                  <!-- <v-textarea
                                  outline
                                  :label="$t('Remark')"
                                  name="remark"
                                  rows="5"
                                  :data-vv-as="$t('Remark')"
                                  style="resize: none;width:100%"
                                  v-model="remark"
                                  :color="theme.color"
                                  light
                                ></v-textarea>-->
                                </div>
                              </div>
                              <div
                                class="text-xs-center"
                                style="padding-top: 15px; padding-bottom: 15px"
                              >
                                <a
                                  href="javascript:void(0);"
                                  @click="openModal()"
                                  style="color: rgb(169, 169, 169)"
                                >
                                  {{
                                    $t(
                                      'By clicking {proceed_payment}, Ive read and',
                                      {
                                        proceed_payment: isNestle
                                          ? 'ทำการสั่งซื้อ'
                                          : $store.getters.isPowerBuyPage
                                          ? 'ติดต่อแอดมิน'
                                          : 'ชำระสินค้า'
                                      }
                                    )
                                  }}
                                  <br />
                                  {{ $t('agree to') }}
                                  <span :style="{ color: theme.color }">
                                    นโยบายความเป็นส่วนตัวและการรับประกัน</span
                                  >.
                                </a>
                              </div>

                              <template v-if="loading">
                                <div class="text-xs-center my-3">
                                  <v-progress-circular
                                    :key="theme.color"
                                    indeterminate
                                    :color="theme.color"
                                  ></v-progress-circular>
                                </div>
                              </template>
                              <template v-else>
                                <p
                                  class="text-xs-center"
                                  style="color: red"
                                  v-if="isCartOutOfStock"
                                >
                                  {{
                                    $t(
                                      'Not enough products in stock, please try to order again.'
                                    )
                                  }}.
                                </p>
                                <p
                                  v-if="notShipping"
                                  style="color: red"
                                  class="text-xs-center"
                                >
                                  ไม่สามารถจัดส่งนอกพื้นที่ได้
                                </p>
                                <p
                                  v-else-if="notReachMinimum"
                                  style="color: red"
                                  class="text-xs-center"
                                >
                                  {{
                                    $t(
                                      'Please order a minimum amount of 500 baht.'
                                    )
                                  }}
                                </p>
                                <div v-else class="text-xs-center">
                                  <v-btn
                                    id="proceedPayment"
                                    dark
                                    :color="theme.color"
                                    :disabled="loading || isCartOutOfStock"
                                    @click="handleSubmit"
                                    :loading="pageLoading || loadingLalamove"
                                    v-if="!isCompletePayment"
                                    style="min-width: 150px"
                                  >
                                    <v-icon class="mr-2"
                                      >mdi-cart-outline</v-icon
                                    >
                                    ชำระสินค้า
                                  </v-btn>

                                  <div
                                    v-if="$store.getters.isPowerBuyPage"
                                    class="mt-2"
                                  >
                                    <v-btn
                                      color="#e3d4ea"
                                      @click="handleCloseWindow"
                                      style="min-width: 150px"
                                    >
                                      {{ $t('back_to_chat') }}
                                    </v-btn>
                                  </div>
                                </div>
                              </template>
                            </template>
                            <template
                              v-else-if="['2c2p'].includes(transferType)"
                            >
                              <template
                                v-if="
                                  ['104716585038207', '362065616073'].includes(
                                    pageProfile.pageid
                                  ) ||
                                  ['tero', 'nestle'].includes(pageProfile.type)
                                "
                              >
                                <form
                                  ref="form2c2p"
                                  id="2c2p-payment-form"
                                  method="POST"
                                  :action="`https://2c2pgateway.zwiz.ai/indexzwiz.php?date=${new Date()}`"
                                >
                                  <input
                                    type="hidden"
                                    v-model="orderid"
                                    name="orderid"
                                  />
                                  <input
                                    type="hidden"
                                    :value="totalPrice ? totalPrice * 100 : 0"
                                    name="amount"
                                  />
                                  <input
                                    type="hidden"
                                    value="bec"
                                    name="theme"
                                  />
                                  <input
                                    type="hidden"
                                    :value="pageProfile.pageid"
                                    name="pageid"
                                  />
                                  <input
                                    type="hidden"
                                    v-model="serverUrl"
                                    name="serverUrl"
                                  />
                                  <input
                                    type="hidden"
                                    :value="payment_option"
                                    name="payment_option"
                                  />
                                </form>
                              </template>

                              <div v-else>
                                <v-card>
                                  <v-card-text>
                                    <form
                                      @submit="submit2c2p"
                                      ref="form2c2p"
                                      id="2c2p-payment-form"
                                      method="POST"
                                      :action="`https://2c2pgateway.zwiz.ai/index.php?${new Date()}`"
                                    >
                                      <div
                                        :class="{
                                          'has-error':
                                            errors.has('Cardholdername')
                                        }"
                                        class="mb-1"
                                      >
                                        <v-text-field
                                          name="Cardholdername"
                                          :data-vv-as="$t('Cardholder Name')"
                                          label="Cardholder Name"
                                          :color="theme.color"
                                          v-model="creditcard.name"
                                          placeholder=" "
                                          v-validate="'required'"
                                          :error="
                                            errors.has('Cardholdername')
                                              ? true
                                              : false
                                          "
                                          :error-messages="
                                            errors.has('Cardholdername')
                                              ? errors.first('Cardholdername')
                                              : ''
                                          "
                                        ></v-text-field>
                                      </div>
                                      <div
                                        :class="{
                                          'has-error': errors.has('cardnumber')
                                        }"
                                        class="mb-1"
                                      >
                                        <v-text-field
                                          data-encrypt="cardnumber"
                                          name="cardnumber"
                                          label="Card Number"
                                          placeholder=" "
                                          v-validate="'required'"
                                          :error="
                                            errors.has('cardnumber')
                                              ? true
                                              : false
                                          "
                                          :error-messages="
                                            errors.has('cardnumber')
                                              ? errors.first('cardnumber')
                                              : ''
                                          "
                                          :color="theme.color"
                                          v-model="creditcard.number"
                                        ></v-text-field>
                                      </div>
                                      <v-layout>
                                        <v-flex xs6>
                                          <div
                                            class="form-control"
                                            :class="{
                                              'has-error':
                                                errors.has('month') ||
                                                errors.has('year')
                                            }"
                                          >
                                            <v-text-field
                                              label="Expire date"
                                              v-themask="'##/##'"
                                              :masked="true"
                                              :error="
                                                errors.has('month') ||
                                                errors.has('year')
                                              "
                                              :error-messages="
                                                errors.has('month')
                                                  ? errors.first('month')
                                                  : errors.has('year')
                                                  ? errors.first('month')
                                                  : ''
                                              "
                                              placeholder="MM/YY"
                                              :color="theme.color"
                                              @input="onChangeExpireDate"
                                              name="expiredate"
                                              v-model="creditcard.validate"
                                            />

                                            <v-text-field
                                              data-encrypt="month"
                                              name="month"
                                              :data-vv-as="'Month'"
                                              style="width: 0; height: 0"
                                              v-validate="'required'"
                                              readonly
                                              class="pa-0"
                                              v-model="creditcard.expiremonth"
                                            />
                                            <v-text-field
                                              name="year"
                                              data-encrypt="year"
                                              class="pa-0"
                                              :data-vv-as="'Year'"
                                              v-validate="'required'"
                                              style="
                                                visibility: hidden;
                                                width: 0;
                                                height: 0;
                                              "
                                              readonly
                                              v-model="creditcard.expireyear"
                                            />
                                          </div>
                                        </v-flex>
                                        <v-flex xs6>
                                          <div
                                            :class="{
                                              'has-error': errors.has('cvv')
                                            }"
                                          >
                                            <v-text-field
                                              label="CVV/CVV2"
                                              v-validate="'required'"
                                              :data-vv-as="'CVV/CVV2'"
                                              data-encrypt="cvv"
                                              name="cvv"
                                              v-themask="['###', '####']"
                                              placeholder=" "
                                              :color="theme.color"
                                              v-model="creditcard.cvv"
                                              :error="
                                                errors.has('cvv') ? true : false
                                              "
                                              :error-messages="
                                                errors.has('cvv')
                                                  ? errors.first('cvv')
                                                  : ''
                                              "
                                            />
                                          </div>
                                        </v-flex>
                                      </v-layout>
                                      <input
                                        type="hidden"
                                        v-model="orderid"
                                        name="orderid"
                                      />
                                      <input
                                        type="hidden"
                                        v-model="amount"
                                        name="amount"
                                      />
                                      <input
                                        type="hidden"
                                        v-model="facebookname"
                                        name="facebookname"
                                      />
                                      <input
                                        type="hidden"
                                        v-model="pageid"
                                        name="pageid"
                                      />
                                    </form>
                                  </v-card-text>
                                  <div class="pb-3 text-xs-center">
                                    <img
                                      width="120px"
                                      src="@/assets/img/creditcardlogo.png"
                                    />
                                  </div>
                                </v-card>
                              </div>
                              <div
                                class="text-xs-center"
                                style="padding-top: 15px; padding-bottom: 15px"
                              >
                                <a
                                  href="javascript:void(0);"
                                  @click="openModal()"
                                  style="color: rgb(169, 169, 169)"
                                >
                                  {{
                                    $t(
                                      'By clicking {proceed_payment}, Ive read and',
                                      {
                                        proceed_payment: isNestle
                                          ? 'ทำการสั่งซื้อ'
                                          : $store.getters.isPowerBuyPage
                                          ? 'ติดต่อแอดมิน'
                                          : 'ชำระสินค้า'
                                      }
                                    )
                                  }}
                                  <br />
                                  {{ $t('agree to') }}
                                  <span :style="{ color: theme.color }">
                                    นโยบายความเป็นส่วนตัวและการรับประกัน</span
                                  >.
                                </a>
                              </div>
                              <template v-if="loading">
                                <div class="text-xs-center my-3">
                                  <v-progress-circular
                                    :key="theme.color"
                                    indeterminate
                                    :color="theme.color"
                                  ></v-progress-circular>
                                </div>
                              </template>

                              <template v-else>
                                <p
                                  class="text-xs-center"
                                  style="color: red"
                                  v-if="isCartOutOfStock"
                                >
                                  {{
                                    $t(
                                      'Not enough products in stock, please try to order again.'
                                    )
                                  }}.
                                </p>
                                <div
                                  class="text-xs-center"
                                  v-if="!isCompletePayment"
                                >
                                  <v-btn
                                    v-if="isCDS && transferType == '2c2p'"
                                    dark
                                    :color="theme.color"
                                    :disabled="loading || isCartOutOfStock"
                                    @click="handleSubmit"
                                    :loading="pageLoading"
                                  >
                                    <v-icon class="mr-2"
                                      >mdi-cart-outline</v-icon
                                    >
                                    {{
                                      isNestle
                                        ? 'ทำการสั่งซื้อ'
                                        : $store.getters.isPowerBuyPage
                                        ? 'ติดต่อแอดมิน'
                                        : $route.query.shoptoken
                                        ? $t('Proceed Payment1')
                                        : $t('Proceed Payment')
                                    }}
                                  </v-btn>
                                  <v-btn
                                    dark
                                    v-else
                                    :color="theme.color"
                                    :disabled="loading || isCartOutOfStock"
                                    @click="handleSubmit"
                                    :loading="pageLoading"
                                  >
                                    <v-icon class="mr-2"
                                      >mdi-cart-outline</v-icon
                                    >
                                    {{
                                      isNestle
                                        ? 'ทำการสั่งซื้อ'
                                        : $store.getters.isPowerBuyPage
                                        ? 'ติดต่อแอดมิน'
                                        : $route.query.shoptoken
                                        ? $t('Proceed Payment1')
                                        : $t('Proceed Payment')
                                    }}
                                  </v-btn>
                                </div>
                              </template>
                            </template>
                            <template
                              v-else-if="
                                ['creditgbprime'].includes(transferType)
                              "
                            >
                              <div>
                                <v-card class="elevation-0">
                                  <v-card-text>
                                    <form
                                      ref="form-gbcredit"
                                      id="gbcredit-payment-form"
                                      method="POST"
                                    >
                                      <div
                                        :class="{
                                          'has-error':
                                            errors.has('Cardholdername')
                                        }"
                                        class="mb-1"
                                      >
                                        <v-text-field
                                          name="Cardholdername"
                                          :data-vv-as="$t('Cardholder Name')"
                                          label="Cardholder Name"
                                          :color="theme.color"
                                          v-model="creditcard.name"
                                          maxlength="120"
                                          placeholder=" "
                                          v-validate="'required'"
                                          :error="
                                            errors.has('Cardholdername')
                                              ? true
                                              : false
                                          "
                                          :error-messages="
                                            errors.has('Cardholdername')
                                              ? errors.first('Cardholdername')
                                              : ''
                                          "
                                        ></v-text-field>
                                      </div>
                                      <div
                                        :class="{
                                          'has-error': errors.has('cardnumber')
                                        }"
                                        class="mb-1"
                                      >
                                        <v-text-field
                                          data-encrypt="cardnumber"
                                          name="cardnumber"
                                          v-themask="'#### #### #### #### ###'"
                                          label="Card Number"
                                          placeholder=" "
                                          v-validate="'required|credit_card'"
                                          :error="
                                            errors.has('cardnumber')
                                              ? true
                                              : false
                                          "
                                          :error-messages="
                                            errors.has('cardnumber')
                                              ? errors.first('cardnumber')
                                              : ''
                                          "
                                          :color="theme.color"
                                          v-model="creditcard.number"
                                        ></v-text-field>
                                      </div>
                                      <v-layout>
                                        <v-flex xs6 class="pr-1">
                                          <div
                                            class="form-control"
                                            :class="{
                                              'has-error':
                                                errors.has('month') ||
                                                errors.has('year')
                                            }"
                                          >
                                            <v-text-field
                                              label="Expire date"
                                              v-themask="'##/##'"
                                              :masked="true"
                                              :error="
                                                errors.has('month') ||
                                                errors.has('year')
                                              "
                                              :error-messages="
                                                errors.has('month')
                                                  ? errors.first('month')
                                                  : errors.has('year')
                                                  ? errors.first('month')
                                                  : ''
                                              "
                                              placeholder="MM/YY"
                                              :color="theme.color"
                                              @input="onChangeExpireDate"
                                              name="expiredate"
                                              v-model="creditcard.validate"
                                            />

                                            <v-text-field
                                              data-encrypt="month"
                                              name="month"
                                              :data-vv-as="'Month'"
                                              style="width: 0; height: 0"
                                              v-validate="'required'"
                                              readonly
                                              class="pa-0"
                                              v-model="creditcard.expiremonth"
                                            />
                                            <v-text-field
                                              name="year"
                                              data-encrypt="year"
                                              class="pa-0"
                                              :data-vv-as="'Year'"
                                              v-validate="'required'"
                                              style="
                                                visibility: hidden;
                                                width: 0;
                                                height: 0;
                                              "
                                              readonly
                                              v-model="creditcard.expireyear"
                                            />
                                          </div>
                                        </v-flex>
                                        <v-flex xs6 class="pl-1">
                                          <div
                                            :class="{
                                              'has-error': errors.has('cvv')
                                            }"
                                          >
                                            <v-text-field
                                              label="CVV/CVV2"
                                              v-validate="'required'"
                                              :data-vv-as="'CVV/CVV2'"
                                              data-encrypt="cvv"
                                              name="cvv"
                                              v-themask="['###', '####']"
                                              placeholder=" "
                                              :color="theme.color"
                                              v-model="creditcard.cvv"
                                              :error="
                                                errors.has('cvv') ? true : false
                                              "
                                              :error-messages="
                                                errors.has('cvv')
                                                  ? errors.first('cvv')
                                                  : ''
                                              "
                                            />
                                          </div>
                                        </v-flex>
                                      </v-layout>
                                      <input
                                        type="hidden"
                                        v-model="orderid"
                                        name="orderid"
                                      />
                                      <input
                                        type="hidden"
                                        v-model="amount"
                                        name="amount"
                                      />
                                      <input
                                        type="hidden"
                                        v-model="facebookname"
                                        name="facebookname"
                                      />
                                      <input
                                        type="hidden"
                                        v-model="pageid"
                                        name="pageid"
                                      />
                                    </form>
                                  </v-card-text>
                                  <div class="pb-3 text-xs-center">
                                    <img
                                      width="120px"
                                      src="@/assets/img/creditcardlogo.png"
                                    />
                                  </div>
                                </v-card>
                              </div>
                              <div
                                class="text-xs-center"
                                style="padding-top: 15px; padding-bottom: 15px"
                              >
                                <a
                                  href="javascript:void(0);"
                                  @click="openModal()"
                                  style="color: rgb(169, 169, 169)"
                                >
                                  {{
                                    $t(
                                      'By clicking {proceed_payment}, Ive read and',
                                      {
                                        proceed_payment: isNestle
                                          ? 'ทำการสั่งซื้อ'
                                          : $store.getters.isPowerBuyPage
                                          ? 'ติดต่อแอดมิน'
                                          : 'ชำระสินค้า'
                                      }
                                    )
                                  }}
                                  <br />
                                  {{ $t('agree to') }}
                                  <span :style="{ color: theme.color }">
                                    นโยบายความเป็นส่วนตัวและการรับประกัน</span
                                  >.
                                </a>
                              </div>
                              <template v-if="loading">
                                <div class="text-xs-center my-3">
                                  <v-progress-circular
                                    :key="theme.color"
                                    indeterminate
                                    :color="theme.color"
                                  ></v-progress-circular>
                                </div>
                              </template>

                              <template v-else>
                                <p
                                  class="text-xs-center"
                                  style="color: red"
                                  v-if="isCartOutOfStock"
                                >
                                  {{
                                    $t(
                                      'Not enough products in stock, please try to order again.'
                                    )
                                  }}.
                                </p>
                                <div class="text-xs-center">
                                  <v-btn
                                    dark
                                    :color="theme.color"
                                    :disabled="loading || isCartOutOfStock"
                                    @click="gbcreditSubmit"
                                    :loading="pageLoading"
                                  >
                                    <v-icon class="mr-2"
                                      >mdi-cart-outline</v-icon
                                    >
                                    {{
                                      isNestle
                                        ? 'ทำการสั่งซื้อ'
                                        : $store.getters.isPowerBuyPage
                                        ? 'ติดต่อแอดมิน'
                                        : $route.query.shoptoken
                                        ? $t('Proceed Payment1')
                                        : $t('Proceed Payment')
                                    }}
                                  </v-btn>
                                </div>
                              </template>
                            </template>
                            <template
                              v-else-if="['qrcode'].includes(transferType)"
                            >
                              <div
                                class="text-xs-center"
                                style="padding-top: 15px; padding-bottom: 15px"
                              >
                                <a
                                  href="javascript:void(0);"
                                  @click="openModal()"
                                  style="color: rgb(169, 169, 169)"
                                >
                                  {{
                                    $t(
                                      'By clicking {proceed_payment}, Ive read and',
                                      {
                                        proceed_payment: isNestle
                                          ? 'ทำการสั่งซื้อ'
                                          : $store.getters.isPowerBuyPage
                                          ? 'ติดต่อแอดมิน'
                                          : 'ชำระสินค้า'
                                      }
                                    )
                                  }}
                                  <br />
                                  {{ $t('agree to') }}
                                  <span :style="{ color: theme.color }">
                                    นโยบายความเป็นส่วนตัวและการรับประกัน</span
                                  >.
                                </a>
                              </div>

                              <template v-if="loading">
                                <div class="text-xs-center my-3">
                                  <v-progress-circular
                                    :key="theme.color"
                                    indeterminate
                                    :color="theme.color"
                                  ></v-progress-circular>
                                </div>
                              </template>
                              <template v-else>
                                <p
                                  class="text-xs-center"
                                  style="color: red"
                                  v-if="isCartOutOfStock"
                                >
                                  {{
                                    $t(
                                      'Not enough products in stock, please try to order again.'
                                    )
                                  }}.
                                </p>
                                <div class="text-xs-center">
                                  <v-btn
                                    dark
                                    :color="theme.color"
                                    :disabled="loading || isCartOutOfStock"
                                    @click="qrHandleSubmit"
                                    :loading="pageLoading || loadingQrcode"
                                  >
                                    <v-icon class="mr-2"
                                      >mdi-cart-outline</v-icon
                                    >
                                    {{
                                      isNestle
                                        ? 'ทำการสั่งซื้อ'
                                        : $store.getters.isPowerBuyPage
                                        ? 'ติดต่อแอดมิน'
                                        : $route.query.shoptoken
                                        ? $t('Proceed Payment1')
                                        : $t('Proceed Payment')
                                    }}
                                  </v-btn>
                                </div>
                              </template>
                            </template>
                            <div v-show="['paypal'].includes(transferType)">
                              <div
                                class="text-xs-center"
                                style="padding-top: 15px; padding-bottom: 15px"
                              >
                                <a
                                  href="javascript:void(0);"
                                  @click="openModal()"
                                  style="color: rgb(169, 169, 169)"
                                >
                                  {{
                                    $t(
                                      'By clicking {proceed_payment}, Ive read and',
                                      {
                                        proceed_payment: isNestle
                                          ? 'ทำการสั่งซื้อ'
                                          : $store.getters.isPowerBuyPage
                                          ? 'ติดต่อแอดมิน'
                                          : 'ชำระสินค้า'
                                      }
                                    )
                                  }}
                                  <br />
                                  {{ $t('agree to') }}
                                  <span :style="{ color: theme.color }">
                                    นโยบายความเป็นส่วนตัวและการรับประกัน</span
                                  >.
                                </a>
                              </div>

                              <template v-if="loading">
                                <div class="text-xs-center my-3">
                                  <v-progress-circular
                                    :key="theme.color"
                                    indeterminate
                                    :color="theme.color"
                                  ></v-progress-circular>
                                </div>
                              </template>
                              <div v-show="!loading">
                                <p
                                  class="text-xs-center"
                                  style="color: red"
                                  v-if="isCartOutOfStock"
                                >
                                  {{
                                    $t(
                                      'Not enough products in stock, please try to order again.'
                                    )
                                  }}.
                                </p>
                                <div
                                  ref="paypal-button-container"
                                  class="text-xs-center"
                                  v-show="!isCartOutOfStock"
                                >
                                  <div id="paypal-button"></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </v-card-text>
                      </v-card>
                    </div>
                  </div>
                </v-flex>
              </v-layout>
            </v-container>
            <div
              class="text-xs-center"
              v-if="
                isEditAddress &&
                !$route.query.shoptoken &&
                product_detail_json &&
                (product_detail_json.status === 'paid' ||
                  product_detail_json.status === 'ordered')
              "
              style="margin-top: -30px; margin-bottom: 20px"
            >
              <v-btn
                dark
                :color="theme.color"
                :disabled="loading"
                @click="editAddressSubmit"
                :loading="pageLoading"
              >
                <v-icon class="mr-2">mdi-cart-outline</v-icon>
                {{ $t('editSubmit') }}
              </v-btn>
            </div>
          </form>
        </div>
      </div>
      <div class="seagull-footer">
        <div>
          <div>บริษัท ไทยสเตนเลสสตีล จำกัด</div>
          <div>&copy; 2023 Thai Stainless Steel Co., Ltd.</div>
        </div>
      </div>
    </v-app>
    <Loading :payment="paymentLoading" v-if="!pageLoading && loading"></Loading>
    <term-and-condition
      :pageid="pageProfile.pageid"
      v-if="showTerm"
      @close="close()"
    ></term-and-condition>
    <v-dialog v-model="showQrCode" max-width="376" persistent>
      <v-card>
        <div class="text-xs-right">
          <v-btn fab small flat @click="closeQrCode">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <v-card-text>
          <template v-if="qrimage">
            <img :src="qrimage" style="width: 100%" />
            <div class="text-xs-center mt-2">
              {{
                $t(
                  'If you already have proceeded a payment, you may close this popup window.'
                )
              }}
            </div>
          </template>
        </v-card-text>
      </v-card>
    </v-dialog>
    <form
      style="display: none"
      ref="formgbprime"
      id="mobileBankingform"
      action="https://api.gbprimepay.com/v2/mobileBanking"
      method="POST"
    >
      <div>
        <label>public_key: </label>
        <input name="publicKey" :value="gbFormData.public_key" />
      </div>

      <div>
        <label>referenceNo: </label>
        <input name="referenceNo" :value="gbFormData.referenceNo" />
      </div>

      <div>
        <label>backgroundUrl: </label>
        <input
          name="backgroundUrl"
          :value="`${gbFormData.backgroundUrl}?userid=${userid}&pageid=${pageid}`"
        />
      </div>

      <div>
        <label>responseUrl: </label>
        <input name="responseUrl" :value="gbFormData.responseUrl" />
      </div>
      <div>
        <label>Amount: </label>
        <input
          type="number"
          name="amount"
          maxlength="13"
          placeholder="Amount"
          :value="gbFormData.amount"
        />
      </div>
      <div>
        <label>Bank Code: </label>
        <input name="bankCode" :value="gbFormData.bankCode" />
      </div>
      <div>
        <label>Checksum: </label>
        <input type="text" name="checksum" :value="gbFormData.hash" />
      </div>
    </form>

    <template v-if="gbcharge">
      <form
        ref="gbchargeform"
        name="form"
        :action="`${gbpath}/v1/tokens/3d_secured`"
        method="POST"
      >
        publicKey:
        <input type="text" name="publicKey" :value="gbpublickey" /><br />
        gbpReferenceNo:
        <input
          type="text"
          name="gbpReferenceNo"
          :value="gbcharge.gbpReferenceNo"
        />
      </form>
    </template>

    <v-dialog v-model="successDialog" persistent max-width="400px">
      <v-card>
        <div
          class="pointer"
          style="position: absolute; right: 0px; padding: 6px"
        >
          <v-icon v-if="countDown === 0" @click="Confirm">mdi-close</v-icon>
          <small v-else>{{ countDown }} {{ $t('second') }}</small>
        </div>
        <v-card-title
          style="
            place-content: center;
            display: block;
            text-align: -webkit-center;
          "
        >
          <v-icon style="font-size: 115px" :color="theme.color"
            >mdi-check-circle</v-icon
          >
          <h2 class="mb-4 mt-2">{{ $t(`Complete the transaction`) }}</h2>
          <h3 class="mt-2 mb-3 color-white">
            {{ $t(`Your order number is`) }}: {{ orderid }}
          </h3>
          <!-- <h4 class="mb-3">
            <v-icon>mdi-cellphone-screenshot </v-icon>
            {{ $t('Please take pictures for evidence.') }}
          </h4> -->
          <v-btn
            class="mt-3"
            v-if="countDown === 0"
            dark
            :color="theme.color"
            :disabled="loading"
            @click="Confirm"
          >
            {{ $t('Confirm') }}
          </v-btn>
        </v-card-title></v-card
      >
    </v-dialog>
  </div>
</template>

<script>
import MainTransfer from './MainTransfer'
import PaymentInfo from './PaymentInfo.vue'
import TermAndCondition from '@/components/ecommerce/SeagullTermAndCondition.vue'

export default {
  mixins: [MainTransfer],
  components: {
    PaymentInfo,
    TermAndCondition
  },
  data() {
    return {
      needTaxInvoice: false
    }
  },
  methods: {
    formattedCombineAddress2(address) {
      try {
        if (address) {
          const shippingAddress = address.address
          let combineAddress = shippingAddress
            ? shippingAddress.replace(/,/g, '')
            : ''

          if (
            address.sub_district &&
            address.district &&
            address.province &&
            address.zipcode
          ) {
            const inBangkok = address.province == 'กรุงเทพมหานคร'
            combineAddress = combineAddress.replace(address.zipcode, '')
            combineAddress =
              `${combineAddress ? `${combineAddress} , ` : ''}` +
              [
                (inBangkok ? 'แขวง' : 'ตำบล') +
                  address.sub_district.replace(/,/g, ''),
                (inBangkok ? 'เขต' : 'อำเภอ') +
                  address.district.replace(/,/g, ''),
                'จังหวัด' + address.province.replace(/,/g, ''),
                address.zipcode.replace(/,/g, '')
              ].join(' , ')
          }

          return combineAddress
        } else {
          return null
        }
      } catch (error) {
        // eslint-disable-next-line
        console.error(error)
        return null
      }
    },
    handleChangeTaxAddressSameAddress(evt) {
      if (!evt) {
        this.tax_name = ''
        this.tax_id = ''
        this.taxAddress = ''
      } else {
        let address = this.formattedCombineAddress2(this.shippingAddress2)
        let addressDetail = []
        if (this.shippingAddress) {
          addressDetail.push(this.shippingAddress)
        }
        if (address) {
          addressDetail.push(address)
        }
        addressDetail = addressDetail.join(' , ')
        this.tax_name = this.customerName
        this.tax_id = ''
        this.taxAddress = addressDetail
      }
    }
  }
}
</script>

<style>
.v-input .v-label {
  height: 23px !important;
  line-height: 23px !important;
}
</style>
